#import "./SageGiftAccountDifferenceFields.graphql"

query GetSageGiftAccountDifferences(
  $page: Int
  $limit: Int
  $statuses: [SageGiftAccountDifferenceStatus!]
  $kinds: [SageGiftAccountDifferenceKind!]
  $sageGiftAccountId: ID
  $fundAccountId: ID
  $sortBy: String
) {
  sageGiftAccountDifferences(
    page: $page
    limit: $limit
    statuses: $statuses
    kinds: $kinds
    sageGiftAccountId: $sageGiftAccountId
    fundAccountId: $fundAccountId
    sortBy: $sortBy
  ) {
    collection {
      ...SageGiftAccountDifferenceFields
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
